module.exports = __webpack_public_path__ + "static/media/kahuna-collection.f217b9e3.jpg";